import styled from 'styled-components'

export const Container = styled.div`
    height: 100%;
    overflow: hidden;
    position: relative;
    display: flex;
    width: 100%;
    flex-direction: column;
    .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 15px;
        height: 48px;
        font-size: 16px;
        background: white;
        box-shadow: 0px 1px 14px rgba(0, 0, 0, 0.12);
        z-index: 9999;
    }
    #root,
    .rt-chat-global,
    .rt-chat-global-window {
        position: relative;
        height: 100%;
        width: 100%;
    }
`
